import store from '../store/index'
import {showSuccessMsg} from "@utils/msg";
import router from '../router/index'
import {COMMIT_CHANGE_LOGIN_MODAL} from "@constants/mutation-type/login-mutation-type";
import goldIcon from "@assets/img/index/gold-diamond.png"
import diamondIcon from '@assets/img/index/transparent-diamond.png'
import silveryIcon from '@assets/img/index/silvery-diamond.png'

// 跳转统一判断;
export function isJumpMemberPage() {
    // 判断是否登录
    if (!store.state.login.isLogin) {
        store.commit(COMMIT_CHANGE_LOGIN_MODAL, {
            showLoginModal: true
        })
        return
    }
    // 不是会员跳转会员开通页面
    if (store.state.login.userInfo.memberFlag == 0) {
        router.push('other/member-ship')
    } else {
        showSuccessMsg('您已是会员')
    }
}

// 黄金会员 青铜会员 钻石会员显示数据
export function memberDisplay() {
    if(!store.state.login.isLogin)return {name: '青铜会员', icon: silveryIcon}
    switch (store.state.login.userInfo.memberFlag) {
        case 0:
            return {name: '青铜会员', icon: silveryIcon}
        case 1:
            return {name:'黄金会员',icon:goldIcon}
        case 2:
            return {name:'钻石会员',icon:diamondIcon}
    }
}
